var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { Accordion, AccordionSet, MultiColumnList, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import css from "./reports.module.css";
var GROUP_ORDER = [
    "COMMERCIAL",
    "UNIVERSITY",
    "SCHOOL",
    "ACADEMIC",
    "STATE",
    "MUNICIPALITY",
    "NONPROFIT",
    "OTHER",
];
export var ScknReportResults = function (_a) {
    var data = _a.data;
    var _b = useIntl(), formatMessage = _b.formatMessage, formatNumber = _b.formatNumber;
    var groupFormatter = {
        group: function (row) {
            return formatMessage({
                id: "ui-br-agency.outputs.sckn-report.group.".concat(row.group),
                defaultMessage: row.group,
            });
        },
        activePublishers: function (row) {
            return formatNumber(row.activePublishers);
        },
        assignedIsbns: function (row) { return formatNumber(row.assignedIsbns); },
        assignedIsmns: function (row) { return formatNumber(row.assignedIsmns); },
    };
    var topFormatter = {
        name: function (row) { return row.name; },
        companyNumber: function (row) { var _a; return (_a = row.companyNumber) !== null && _a !== void 0 ? _a : "—"; },
        assignedCount: function (row) { return formatNumber(row.assignedCount); },
    };
    var sortedGroups = __spreadArray([], data.groupStats, true).sort(function (a, b) { return GROUP_ORDER.indexOf(a.group) - GROUP_ORDER.indexOf(b.group); });
    var topColumnMapping = {
        name: formatMessage({
            id: "ui-br-agency.outputs.sckn-report.column.publisher",
        }),
        companyNumber: formatMessage({
            id: "ui-br-agency.outputs.sckn-report.column.ico",
        }),
        assignedCount: formatMessage({
            id: "ui-br-agency.outputs.sckn-report.column.assignedCount",
        }),
    };
    var groupColumns = [
        "group",
        "activePublishers",
        "assignedIsbns",
        "assignedIsmns",
    ];
    var topColumns = [
        "name",
        "companyNumber",
        "assignedCount",
    ];
    return (React.createElement("div", { className: css.resultsWrapper },
        React.createElement("h3", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.sckn-report.results.title", values: { year: data.year } })),
        React.createElement("div", { className: css.totals },
            React.createElement("strong", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.sckn-report.totals.publishers" }),
                ":"),
            " ",
            formatNumber(data.totalActivePublishers),
            " | ",
            React.createElement("strong", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.sckn-report.totals.isbns" }),
                ":"),
            " ",
            formatNumber(data.totalAssignedIsbns),
            " | ",
            React.createElement("strong", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.sckn-report.totals.ismns" }),
                ":"),
            " ",
            formatNumber(data.totalAssignedIsmns)),
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.outputs.sckn-report.section.groups",
                }), open: true },
                React.createElement(MultiColumnList, { contentData: sortedGroups, formatter: groupFormatter, visibleColumns: groupColumns, columnMapping: {
                        group: formatMessage({
                            id: "ui-br-agency.outputs.sckn-report.column.group",
                        }),
                        activePublishers: formatMessage({
                            id: "ui-br-agency.outputs.sckn-report.column.activePublishers",
                        }),
                        assignedIsbns: formatMessage({
                            id: "ui-br-agency.outputs.sckn-report.column.isbns",
                        }),
                        assignedIsmns: formatMessage({
                            id: "ui-br-agency.outputs.sckn-report.column.ismns",
                        }),
                    }, interactive: false })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.outputs.sckn-report.section.topCommercial",
                }) },
                React.createElement(MultiColumnList, { contentData: data.topCommercial, formatter: topFormatter, visibleColumns: topColumns, columnMapping: topColumnMapping, interactive: false })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.outputs.sckn-report.section.topUniversity",
                }) },
                React.createElement(MultiColumnList, { contentData: data.topUniversity, formatter: topFormatter, visibleColumns: topColumns, columnMapping: topColumnMapping, interactive: false })),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.outputs.sckn-report.section.topMunicipality",
                }) },
                React.createElement(MultiColumnList, { contentData: data.topMunicipality, formatter: topFormatter, visibleColumns: topColumns, columnMapping: topColumnMapping, interactive: false })))));
};
